import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMisc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 48,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 4a3 3 0 013-3h19.93a4 4 0 012.83 1.17l11.07 11.07A4 4 0 0139 16.07V44a3 3 0 01-3 3H4a3 3 0 01-3-3V4z",
			fill: "#fff",
			stroke: "#0E4EFB",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.4 22.76l.88 3.47 1-3.47h2.21V32H9.86v-2.74l.07-4.32-1.21 4.01h-.88l-1.09-3.84.08 4.15V32H5.19v-9.24h2.22zm6.02 0h5.34v1.44h-1.8v6.37h1.8V32h-5.34v-1.43h1.76V24.2h-1.76v-1.44zm12.21 6.83c0-.17-.03-.32-.09-.47a1.02 1.02 0 00-.29-.4 1.98 1.98 0 00-.54-.34c-.22-.1-.5-.2-.83-.29-.4-.11-.78-.25-1.15-.41a4.22 4.22 0 01-.97-.6c-.27-.23-.5-.5-.67-.81-.16-.31-.25-.67-.25-1.07a2.26 2.26 0 01.94-1.87c.29-.23.63-.4 1.03-.52a4.37 4.37 0 012.62.03c.4.14.74.34 1.03.6a2.64 2.64 0 01.92 2.03h-1.74c-.01-.2-.05-.4-.12-.57a1.25 1.25 0 00-.77-.74 1.9 1.9 0 00-.67-.1c-.24 0-.45.02-.64.08a1.3 1.3 0 00-.46.24 1.03 1.03 0 00-.26 1.3c.09.14.21.26.38.38.16.1.36.21.6.3.23.1.5.18.8.26.42.13.8.28 1.16.45.36.18.66.4.92.64a2.55 2.55 0 01.8 1.87 2.32 2.32 0 01-.91 1.88c-.29.22-.63.38-1.03.5a4.87 4.87 0 01-3-.16 3.7 3.7 0 01-.75-.42 2.74 2.74 0 01-1.13-2.25h1.76c0 .28.05.52.14.72.1.2.21.36.37.49.16.12.35.22.57.28a2.88 2.88 0 001.37 0c.18-.05.34-.13.47-.23a1 1 0 00.29-.35c.07-.13.1-.29.1-.45zm9.43-.48c-.03.46-.13.88-.3 1.25a2.89 2.89 0 01-1.72 1.56 3.96 3.96 0 01-2.78-.09c-.42-.2-.77-.48-1.06-.84-.29-.36-.51-.8-.66-1.3A5.82 5.82 0 0128.3 28v-1.25c0-.61.08-1.17.24-1.68.16-.5.39-.94.69-1.3a3.06 3.06 0 012.5-1.16c.5 0 .95.08 1.34.22a2.85 2.85 0 011.68 1.6c.16.38.26.81.3 1.3H33.3a2.92 2.92 0 00-.13-.73c-.06-.2-.16-.38-.29-.51a1.1 1.1 0 00-.47-.31c-.18-.08-.4-.11-.67-.11s-.51.06-.72.18c-.2.11-.37.29-.5.52a2.7 2.7 0 00-.3.84c-.06.33-.1.7-.1 1.13v1.26c0 .9.14 1.58.39 2.02.26.43.66.65 1.22.65.46 0 .83-.12 1.1-.37.27-.25.42-.65.45-1.2h1.79z",
			fill: "#0E4EFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.59 13H30a3 3 0 01-3-3V2.41L37.59 13z",
			fill: "#fff",
			stroke: "#0E4EFB",
			strokeWidth: 2
		})
	]
});
export default SvgMisc;
